import { useEffect } from 'react';
import { LEAK_ALARM_POLL_MS } from './constants';
import { useLeakAlarmStore } from './use-leak-alarm-store';

const pollers = new Map();

const retainPolling = (deviceId) => {
  const entry = pollers.get(deviceId) ?? { refs: 0, timer: null };
  entry.refs += 1;

  if (!entry.timer) {
    entry.timer = setInterval(() => {
      useLeakAlarmStore.getState().fetchAlarm(deviceId);
    }, LEAK_ALARM_POLL_MS);
  }

  pollers.set(deviceId, entry);

  return () => {
    entry.refs -= 1;
    if (entry.refs > 0) return;
    clearInterval(entry.timer);
    pollers.delete(deviceId);
  };
};

export const useLeakAlarm = (deviceId) => {
  const { alarms, ackingId, fetchAlarm, ackAlarm } = useLeakAlarmStore();
  const alarm = alarms[deviceId];

  useEffect(() => {
    if (!deviceId) return undefined;
    fetchAlarm(deviceId);
    return retainPolling(deviceId);
  }, [deviceId, fetchAlarm]);

  return {
    alarm,
    loaded: alarm !== undefined,
    acking: ackingId === deviceId,
    ack: () => ackAlarm(deviceId),
  };
};
